import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import {
  mapState,
  getDiscountProps,
  createCancelToken,
} from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';

const getDetails = fp.compose(
  fp.map(([productItemId, { discount, unit_price, quantity }]) => ({
    unit_price,
    quantity,
    product_item_id: productItemId,
    discount: getDiscountProps(discount),
  })),
  fp.toPairs
);

const getOrder = fp.get(['data', 'result', 'order']);

export default config => Component =>
  fp.compose(
    withClient(),
    connect(mapState(['cart', 'order', 'member']))
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithCreateOrder');

      componentWillUnmount() {
        !_.isUndefined(this.cancelCreateOrder) && this.cancelCreateOrder();
      }

      onOrderCreate = async () => {
        const {
          client: { POSApi, onError },
          cart: { items },
          order: { customPrice, discount: orderDiscount, points },
          member: { id: memberId },
        } = this.props;

        try {
          const { id, order_no } = getOrder(
            await POSApi.post(
              '/orders',
              {
                points,
                member_id: _.size(memberId) ? memberId : _.noop(),
                total_price: customPrice || _.noop(),
                order_details: getDetails(items),
                discount: getDiscountProps(orderDiscount),
              },
              { cancelToken: createCancelToken(this.cancelCreateOrder) }
            )
          );
          return { orderId: id, orderNumber: order_no };
        } catch (e) {
          onError(e);
        }
      };

      render() {
        return <Component {...this.props} onOrderCreate={this.onOrderCreate} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCreateOrder.js